export const orderExportHeaders = [
    { label: "ID", key: "customerObj.id" },
    { label: "Type", key: "type" },
    { label: "Name (en)", key: "customerObj.name_en" },
    { label: "Name (ar)", key: "customerObj.name_ar" },
    { label: "PACI Email", key: "paciData.PersonalData.EmailAddress" },
    { label: "Gender", key: "paciData.PersonalData.Gender" },
    { label: "Civil ID Expiry", key: "paciData.PersonalData.CardExpiryDate" },
    { label: "Birth Date", key: "paciData.PersonalData.BirthDate" },
    { label: "Nationality", key: "paciData.PersonalData.NationalityEn" },
    { label: "Nationality (Arabic)", key: "paciData.PersonalData.NationalityAr" },
    { label: "Manual", key: "manual" },
    { label: "Transferred Amount", key: "transferAmount" },
    { label: "Transfer Date", key: "transferDate" },
    { label: "Order Creation Date", key: "createdDate" },
    { label: "Order Approval Date", key: "approvalDate" },
    { label: "Order Review Date", key: "reviewDate" },
    { label: "Order Creation Timestamp", key: "created" },
    { label: "Post NAV Amount", key: "postNavAmount" },
    { label: "Fees", key: "fees" },
    { label: "Surplus", key: "surplus" },
    { label: "Units", key: "units" },
    { label: "Mobile", key: "customerObj.mobile" },
    { label: "Fund", key: "fund.name_en" },
    { label: "Fund ID", key: "fund.id" },
    { label: "Fund Currency", key: "fund.currency" },
    { label: "IBAN", key: "iban" },
    { label: "Account #", key: "acct" },
    { label: "RM Email", key: "rm.email" },
    { label: "RM ID", key: "rm.rm_id" },
    { label: "RM Name", key: "rm.name_en" },
    { label: "RM segment", key: "rm.segment" },
    { label: "NAV Date", key: "nav_date" },
    { label: "NAV Per Unit", key: "nav_per_unit" },
    { label: "Status", key: "tags.orderStatus.code" },
    { label: "Passport Name", key: "customerObj.passportData.fullName" },
    { label: "Passport ID", key: "customerObj.passportData.id" },
    { label: "Passport Expiry", key: "customerObj.passportData.expiryDate" },
    { label: "Civil ID", key: "customerObj.civilID" },
    { label: "Commercial Register", key: "customerObj.commercial_register" },
    { label: "Paid", key: "tags.paid.code" },
    { label: "Address", key: "customerObj.address" },
    { label: "PACI Address", key: "customerObj.address_from_finder.DetailsEnglish" },
    { label: "Country of Birth", key: "kyc.placeOfBirth" },
    { label: "PEP", key: "politicallyExposed" },
    { label: "PEP Reason", key: "pepReason" },
    { label: "High Risk Reason", key: "highRiskReason" },
    { label: "Power of Attorney", key: "powerOfAttorney" },
    { label: "KYC mobile", key: "kyc.mobile" },
    { label: "Voting", key: "voting" },
    { label: "Source of Income", key: "kyc.sourcesOfIncome" },
    { label: "Source of Wealth", key: "kyc.sourcesOfWealth" },
    { label: "Client Classification", key: "clientClassification" },
    { label: "Referrer Email", key: "referredBy.email" },
    { label: "Referrer ID", key: "referredBy.rm_id" },
    { label: "Referrer Name", key: "referredBy.name_en" },
    { label: "Referrer Segment", key: "referredBy.segment" },
    { label: "CIF", key: "customerObj.crmID" },
    { label: "risk", key: "kyc.risk_code" },
    { label: "Submitted Email", key: "submittedBy.email" },
    { label: "Submitted ID", key: "submittedBy.rm_id" },
    { label: "Submitted Name", key: "submittedBy.name_en" },
    { label: "Submitted Segment", key: "submittedBy.segment" },
    { label: "Client Segment", key: "customerObj.segment" },
] as const;

export const getOrderExportValue = (order: Record<string, any>, path: string) => {
    let value: any = order;
    for (const part of path.split(".")) {
        if (value == null) return "";
        value = value[part];
    }
    return value ?? "";
};
